import {emotionStyled} from '@packages/utilities/styled';

export const ScrubZoneView = emotionStyled('span')(
  {},
  {
    componentName: 'ScrubZone',
  }
);

export const ScrubZoneOverlayView = emotionStyled('div')(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: 'ew-resize',
    background: 'transparent',
  },
  {
    componentName: 'ScrubZoneOverlay',
  }
);
